<template lang="pug">
  b-container(fluid :class="{ 'is-mobile': isMobile }")
    b-row
      b-col.page-wrap(cols="12")
        div(slot="header").d-flex.justify-content-between.page-header
        b-container(fluid)
          b-row
            b-col(cols="12")
              b-card.mb-3.w-100(no-body)
                div.profile-header(slot="header") {{$t('profile')}}
                b-list-group(flush)
                  b-list-group-item
                    b-row
                      b-col.essential(cols="5" md="3" lg="2") *
                        div.d-inline.ml-1 {{$t('ID')}}
                      b-col(cols="7" md="9" lg="10") {{user.mgrid}}
                  // 비밀번호
                  b-list-group-item
                    b-row
                      b-col.essential.d-flex.align-items-center(cols="5" md="3" lg="2") *
                        div.d-inline.ml-1 {{$t('PW')}}
                      b-col(cols="7" md="9" lg="10")
                        div(v-if="!passwd.modify")
                          b-btn(size="sm", @click="pwInputChange(true)" variant="secondary" ) {{$t('change')}}
                        div(v-else)
                          b-form-group(
                            label-size="sm",
                            :label="$t('enter_old_password')")
                            b-form-input(type="password", autocomplete="new-password", :state="currentPwState" v-model.trim="passwd.current", size="sm")
                          b-form-group(
                            label-size="sm",
                            :description="$t(validatePasswordLevels[this.password_level])",
                            :label="$t('enter_new_password')")
                            b-form-input(type="password", autocomplete="new-password", :state="memberPwState(this.password_level)", v-model.trim="passwd.value", size="sm")
                          b-form-group(
                            label-size="sm",
                            :label="$t('PW_confirm')")
                            b-form-input(type="password", autocomplete="new-password", :state="pwcState", v-model.trim="passwd.confirm", size="sm")
                          div.d-flex.mb-1
                            b-btn(
                              size="sm",
                              variant="success",
                              :disabled="!memberPwState(this.password_level) || !pwcState || !currentPwState",
                              @click="setPassword()",
                              class="mr-2") {{$t('do_change')}}
                            b-btn(size="sm", @click="pwInputChange(false)") {{$t('cancel')}}
                  // 결재프로세스 적용
                  b-list-group-item(v-if='accountType === 1')
                    b-row
                      b-col(cols="5" md="3" lg="2")
                        div {{$t('user_page.apply_approval_process')}}
                      b-col(cols="7" md="9" lg="10")
                        switches.lmm-switch(
                          v-model="user.use_approval"
                          theme="bootstrap"
                          :color="user.use_approval ? 'warning' : 'default'"
                          :disabled="true"
                        )
                  // 사후결재권한
                  b-list-group-item(v-if='accountType === 1')
                    b-row
                      b-col(cols="5" md="3" lg="2")
                        div {{$t('user_page.post_approval_permission')}}
                      b-col(cols="7" md="9" lg="10")
                        switches.lmm-switch(
                          v-model="user.post_approval"
                          theme="bootstrap"
                          :color="user.post_approval ? 'warning' : 'default'"
                          :disabled="true"
                        )
                  // 이름
                  b-list-group-item
                    b-row
                      b-col.essential(cols="5" md="3" lg="2") *
                        div.d-inline.ml-1 {{$t('name')}}
                      b-col(cols="7" md="9" lg="10")
                        editable(
                          name="name"
                          :value="user.name",
                          :wait="wait.name",
                          @changed="valueChange")
                  // 부서
                  b-list-group-item(v-if='accountType === 1')
                    b-row
                      b-col(cols="5" md="3" lg="2")
                        div {{$t('department')}}
                      b-col(cols="7" md="9" lg="10")
                        b-row.justify-content-between
                          b-col
                            span {{ user.department }}
                  // 직책
                  b-list-group-item(v-if='accountType === 1')
                    b-row
                      b-col(cols="5" md="3" lg="2")
                        div {{$t('cowork_position')}}
                      b-col(cols="7" md="9" lg="10")
                        editable(
                          name="position"
                          :value="user.position",
                          :wait="wait.position",
                          @changed="valueChange")
                  // 직급
                  b-list-group-item(v-if='accountType === 1')
                    b-row
                      b-col(cols="5" md="3" lg="2")
                        div {{$t('user_page.position')}}
                      b-col(cols="7" md="9" lg="10")
                        editable(
                          name="rank"
                          :value="user.rank",
                          :wait="wait.rank",
                          @changed="valueChange")
                  // 등록매니저
                  b-list-group-item(v-if='accountType === 1')
                    b-row
                      b-col(cols="5" md="3" lg="2")
                        div {{$t('user_page.registered_manager')}}
                      b-col(cols="7" md="9" lg="10")
                        b-row.justify-content-between
                          b-col
                            span {{ user.dev_current }}
                          b-col.text-right
                            b-button.d-inline-flex(size="sm" @click="showDialogManager = true") {{$t('user_page.view_delete')}}
                  // 매니저한도
                  b-list-group-item(v-if='accountType === 1')
                    b-row
                      b-col(cols="5" md="3" lg="2")
                        div {{$t('user_page.manager_limit')}}
                      b-col(cols="7" md="9" lg="10")
                        span {{ user.mgrdev_limit }}
                  
                  b-list-group-item
                    b-row
                      b-col(cols="5" md="3" lg="2")
                        div {{$t('user_page.registered_remote_device')}}
                      b-col(cols="7" md="9" lg="10")
                        b-row.justify-content-between
                          b-col
                            span {{ user.agent_current }}
                          b-col.text-right
                            b-button.d-inline-flex(size="sm" @click="showDialogAgent = true") {{$t('user_page.view_delete')}}
                  
                  b-list-group-item
                    b-row
                      b-col(cols="5" md="3" lg="2")
                        div {{$t('user_page.remote_device_limit')}}
                      b-col(cols="7" md="9" lg="10")
                        span {{ user.dev_limit }}
                  b-list-group-item
                    b-row
                      b-col(cols="5" md="3" lg="2")
                        div {{$t('user_page.concurrent_sessions_allowed')}}
                      b-col(cols="7" md="9" lg="10")
                        span {{concurrentSessionsText}}
    dialog-manager(:show.sync="showDialogManager" :userPk="user.pk" @close="closeManager")
    dialog-agent(:show.sync="showDialogAgent" :userPk="user.pk" @close="closeAgent")
    dialog-approver2(
      :show.sync="showDialogApprover"
      :title="String($t('dialogs_page.approver_selection'))"
      :step="1"
      @select="selectApprover"
    )
</template>

<script>
import _ from "lodash"
import Switches from "vue-switches"
import { TimezoneConverter } from "@/api/util"
import { user, setDateFmt, FileUploadAPI } from "@/api/access"
// import { DepartmentAPI } from "@/api"
import Editable from "@/components/mixins/editable"
import TzSelect from "@/components/mixins/tzselect"
import { getUserData } from "@/api/access"
import logDeleteVue from "@/components/statistics/log-delete.vue"
import { CompanyFunctionAPI } from "@/api"
import DialogManager from "../components/dialogManager.vue"
import DialogAgent from "../components/dialogAgent.vue"
import DialogApprover2 from "@/components/user/components/dialogApprover2.vue"
import usersAPI from '@/api/users'
import store from '@/api/store'

export default {
  name: "profile-component",
  components: { Editable, TzSelect, Switches, DialogManager, DialogAgent, DialogApprover2 },
  computed: {
    isMobile() {
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
    pwState() {
      return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(this.passwd.value)
    },
    pwcState() {
      return this.passwd.value === this.passwd.confirm
    },
    accountType() {
      return store.get('auth').account_type
    },
    concurrentSessionsText() {
      const basicProduct = ["Free", "Basic", "Corporate"]
      // 원본 요금제(productType)로 판정 — license_type은 LMM을 Corporate로 뭉쳐 구분 불가.
      // total.productType에 백엔드 product_type이 들어있음(getUserData). Free/Basic/Corporate면 '-', LMM이면 값 표시.
      const total = this.user && this.user.license ? this.user.license.total : null
      const productType = total ? total.productType : null

      if (!productType || basicProduct.includes(productType)) {
        return '-'
      }
      return this.auth.concurrent_sessions
    }
  },
  watch: {
    'passwd.current'() {
      this.validateCurrentPassword()
    },
  },
  methods: {
    closeManager(count) {
      this.showDialogManager = false
      this.user.dev_current = count
    },
    closeAgent(count) {
      this.showDialogAgent = false
      this.user.agent_current = count
    },
    memberPwState(passwordLevel) {
      if (passwordLevel === 0) return /^.{4,12}$/.test(this.passwd.value)
      if (passwordLevel === 1) return /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{6,12}$/.test(this.passwd.value)
      if (passwordLevel === 2) return /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(this.passwd.value)
      if (passwordLevel === 3) return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(this.passwd.value)
    },
    resetOTP() {
      let params = {
        context: { path: "reset_n", args: { v: "OTP" } },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: "submit",
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key === "submit") {
          user("flag_create_qrcode", false)
            .then(() => {
              this.AppState.$emit("show-message-dialog", { context: { path: "otp_reset_complete" } })
            })
            .catch(err => {
              // console.error(err)
              this.AppState.$emit("show-message-dialog", { context: { path: "otp_reset_failed" } })
            })
        }
      })
    },
    HelpOTP() {
      this.AppState.$emit("show-helpOTP-dialog", { context: { path: "help_otp" } })
    },
    dragOverHandler(ev) {
      this.dragover = true
    },
    dragLeaveHandler(ev) {
      this.dragover = false
    },
    dropHandler(ev) {
      this.dragover = false
      var file = null
      this.$log.info("[FILE DROPPED]")
      if (ev.dataTransfer.items) {
        if (ev.dataTransfer.items[0].kind === "file") {
          file = ev.dataTransfer.items[0].getAsFile()
        }
      } else file = ev.dataTransfer.files[0]
      // Pass event to removeDragData for cleanup
      // removeDragData(ev)
      this.uploadLogo(file)
    },
    pwInputChange(state) {
      this.passwd.modify = state
      this.passwd.current = ""
      this.passwd.value = ""
      this.passwd.confirm = ""
      this.currentPwState = false
      if (state) {
        this.validateCurrentPassword();
      }
    },
    setPassword() {
      user("pw", this.passwd.value)
        .then(resp => {
          this.AppState.$emit("show-message-dialog", { context: { path: "password_modified" } })
          this.pwInputChange(false)
        })
        .catch(resp => {
          this.AppState.$emit("show-message-dialog", { context: { path: "password_modified_failed" } })
          this.pwInputChange(false)
        })
    },
    dateFmtChange(value) {
      user("date_fmt_id", value).then(resp => {
        let r = setDateFmt(value)
        this.AppState.Info.dateFmt = r.value
      })
    },
    uploadLogo(data) {
      var file = null
      if (data.target) file = data.target.files[0]
      else file = data
      const fd = new FormData()
      fd.append("file", file)

      FileUploadAPI.post("", fd).then(resp => {
        this.AppState.$emit("logo-changed")
        this.timestamp = new Date().getTime()
      })
    },
    toggleChanged(dataKey, dbKey) {
      if (!this.pageMounted) return
      user(dbKey, this[dataKey])
    },
    valueChange(key, value) {
      this.$log.debug(`[CHANGED KEY: ${key}, VALUE: ${value}]`)
      this.wait[key] = true
      user(key, value)
        .then(resp => {
          this.wait[key] = false
        })
        .catch(err => {
          this.wait[key] = false
        })
    },
    timezoneChanged(tz) {
      this.$log.debug(`[TIMEZONE NAME: ${tz.name}, OFFSET: ${tz.offset}]`)
      let id = TimezoneConverter("offset", tz.offset)
      if (id) {
        let tzv = _.assign({}, id, tz)
        this.AppState.Info.timezone = tzv
        this.AppState.$emit("timezone-changed")
      }
    },
    async getData() {
      const resp = await CompanyFunctionAPI.get()

      this.password_level = resp.data.objects[0].password_level
    },

    selectApprover(item) {
      this.showDialogApprover = false
    },
    async validateCurrentPassword() {
      let params = {
        'password': this.passwd.current
      }
      
      if (params.password === '') {
        this.currentPwState = false
        return
      }
      
      let res = await usersAPI.post('validate_password', params)
      let checkResult = res.data.objects.result
      this.currentPwState = checkResult
      
      return checkResult
    },
  },
  created() {
    getUserData(null, err => {
      if (err) this.$log.error("[REFRESH USER DATA FAILED]")
      this.user = user()
      this.dateFormat.value = this.user.date_fmt_id
      this.useOtp = this.user.flag_use_otp
      this.approver_name = this.user.approver_name
      this.approver_id = this.user.approver_id
      this.useRefresh = this.user.flag_refresh
      this.useLiveviewRefresh = this.user.flag_img_refresh

      // 중간관리자권한 GET
      if (this.user.member_type_id === 6) {
        this.useSubManager = true
      } else if (this.user.member_type_id === 1) {
        this.useSubManager = false
      }

      this.timestamp = new Date().getTime()
    })
    this.auth = store.get('auth')
    // this.fetchDepartment()
  },
  mounted() {
    this.pageMounted = true
    this.getData()
  },
  data() {
    return {
      password_level: null,
      timestamp: 0,
      dragover: false,
      pageMounted: false,
      user: {},
      auth: {},
      wait: {
        email: false,
        name: false,
        phone: false,
        tel: false,
        department: false,
        position: false,
        refresh_interval: false,
        rank: false,
      },
      useOtp: false,
      useRefresh: false,
      useLiveviewRefresh: false,
      approver_id: "",
      approver_name: "",
      dateFormat: {
        value: null,
        options: [
          { value: 0, text: "YY/MM/DD" },
          { value: 1, text: "MM/DD/YY" },
          { value: 2, text: "DD/MM/YY" },
        ],
      },
      validatePasswordLevels: [
        this.$t("password_level0"),
        this.$t("password_level1"),
        this.$t("password_level2"),
        this.$t("password_level3")
      ],
      passwd: {
        modify: false,
        current: "",
        value: "",
        confirm: "",
      },
      currentPwState: false,

      useSubManager: false,

      showDialogManager: false,
      showDialogAgent: false,

      showDialogApprover: false,

      departments: [],
    }
  },
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
}

.row,
.col,
.container-fluid,
.col-12 {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

//.page-header {
//  padding: 0 1.5rem 0 1.5rem;
//  margin-bottom: 0.8rem;
//  height: 2rem;
//}

.title {
  font-size: 1.3rem;
  font-weight: bold;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
  > .card-header {
    border-bottom: 1px solid #d2d2d2;
    font-size: 1.2rem;
    font-weight: 500;
  }
}

.list-group-item {
  padding-top: 0.45rem;
  padding-bottom: 0.45rem;
  // border: 1px solid #d2d2d2;
}

.col-2 {
  color: #000000;
  > div {
    margin-left: 0.63rem;
  }
}

.essential {
  color: #ec7211;
  align-items: center;
  > div {
    color: #000000;
  }
}

.fas {
  color: #c5c5c5;
  margin-left: 6px;
  cursor: pointer;
}

.dropdown {
  width: 15%;
}
.custom-select {
  width: 15%;
}

.btn-success {
  color: #ffffff !important;
  font-weight: 400;
  height: 1.3rem;
  display: flex;
  align-items: center;
}

.btn-secondary {
  color: black !important;
  font-weight: 400;
  height: 1.3rem;
  display: flex;
  align-items: center;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #f7f7f7 !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #cbcbcb !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

.is-mobile {
  .list-group-item {
    padding-left: 0;
    padding-right: 0;
  }
}

@media (min-width: 760px) {
  .page-wrap .col-md-3 {
    flex: 0 0 40%;
    max-width: 40%;
  }
  
  .page-wrap .col-md-9 {
    flex: 0 0 60%;
    max-width: 60%;
  }
}

@media (min-width: 820px) {
  .page-wrap .col-md-3 {
    flex: 0 0 30%;
    max-width: 30%;
  }
  
  .page-wrap .col-md-9 {
    flex: 0 0 70%;
    max-width: 70%;
  }
}

@media (min-width: 1223px) {
  .page-wrap .col-lg-2 {
    flex: 0 0 20%;
    max-width: 20%;
  }
  
  .page-wrap .col-lg-10 {
    flex: 0 0 80%;
    max-width: 80%;
  }
}
</style>
